import React from "react";
import { AuthApi } from "@/auth/auth.types";
import { keycloakClient } from "@/auth/keycloak";

const initialState: AuthApi = {
    state: {
        status: "initializing",
        user: null,
        realmRoles: [],
        clientRoles: [],
        error: null,
    },
    login: () => {},
    logout: () => {},
    getToken: () => undefined,
    keycloak: keycloakClient.instance,
};

export const AuthContext = React.createContext<AuthApi>(initialState);
